// Public read of the top-rated helpers cache.
// The cache table has an RLS SELECT policy allowing anyone — safe to query from the browser.
import { queryOptions } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type TopRatedHelper = {
  helper_id: string;
  display_name: string;
  headline: string | null;
  area: string | null;
  avatar_url: string | null;
  avg_rating: number;
  review_count: number;
  recent_jobs: number;
  rank: number;
  trust_score: number;
};

async function fetchTopRated(): Promise<TopRatedHelper[]> {
  const { data, error } = await supabase
    .from("top_rated_helpers_cache")
    .select("helper_id, display_name, headline, area, avatar_url, avg_rating, review_count, recent_jobs, rank, trust_score")
    .order("rank", { ascending: true })
    .limit(8);
  if (error) return [];
  return (data ?? []) as TopRatedHelper[];
}

export const topRatedQueryOptions = queryOptions({
  queryKey: ["top-rated-helpers"],
  queryFn: fetchTopRated,
  staleTime: 5 * 60 * 1000,
  gcTime: 30 * 60 * 1000,
});
